export const MAX_CLOSEST_DEALERS = 2;
